jQuery(document).ready(function ($) {
  if (
    $('body').hasClass('page-template-ocrolus') ||
    $('body').hasClass('page-template-ocrolus-2023') ||
    $('body').hasClass('page-template-ocrolus-2024')
  ) {
    Chart.defaults.color = '#333';
    Chart.defaults.font.family = 'Poppins';
    Chart.defaults.font.size = '18';
    Chart.defaults.font.weight = '600';

    Chart.defaults.borderColor = '#ddd';

    Chart.defaults.elements.point.backgroundColor = '#0064dd';
    Chart.defaults.elements.point.radius = 5;

    Chart.defaults.datasets.bar.barPercentage = 1;
    Chart.defaults.datasets.bar.categoryPercentage = 0.6;

    Chart.defaults.animation = false;
    Chart.defaults.responsive = true;
    Chart.defaults.maintainAspectRatio = false;

    Chart.defaults.scale.ticks.padding = 16;
    Chart.defaults.scale.ticks.autoSkip = false;
    Chart.defaults.scale.ticks.font = {
      weight: '400',
      size: window.innerWidth > 600 ? 18 : 12,
    };

    Chart.defaults.scale.grid.lineWidth = 3;
    Chart.defaults.scale.grid.color = '#ddd';
    Chart.defaults.scale.grid.tickColor = '#ddd';

    Chart.defaults.plugins.legend.position = 'bottom';
    Chart.defaults.plugins.legend.onClick = null;

    Chart.defaults.plugins.legend.labels.boxHeight = 12;
    Chart.defaults.plugins.legend.labels.boxWidth = 12;
    Chart.defaults.plugins.legend.labels.padding = 32;

    Chart.defaults.plugins.tooltip.bodyFont = { weight: '400', size: '12' };
    Chart.defaults.plugins.tooltip.titleFont = { size: '12' };
    Chart.defaults.plugins.tooltip.titleAlign = 'center';
    Chart.defaults.plugins.tooltip.bodyAlign = 'center';
    Chart.defaults.plugins.tooltip.padding = 16;
    Chart.defaults.plugins.tooltip.backgroundColor = 'rgba(51,51,51,0.9)';
    Chart.defaults.plugins.tooltip.displayColors = false;
    Chart.defaults.plugins.tooltip.xAlign = 'center';
    Chart.defaults.plugins.tooltip.yAlign = 'bottom';
  }
});
